import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UsersComponentComponent } from './users-component.component';
import { UserBusinessComponent } from './user-business/user-business.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserModulesComponent } from './user-modules/user-modules.component';
import { UserAuditComponent } from './user-audit/user-audit.component';
import { UserAssignModalComponent } from './user-assign-modal/user-assign-modal.component';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { FilterObjPipe } from '../shared/pipes/filter-obj.pipe';

@NgModule({
  declarations: [
    UsersComponentComponent,
    UserBusinessComponent,
    UserDetailsComponent,
    UserModulesComponent,
    UserAuditComponent,
    UserAssignModalComponent,
    FilterObjPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppNgAppkitModule,
    MatDialogModule,
    SharedDirectivesModule,
  ],
  providers: [],
  exports: [
    UsersComponentComponent,
    UserBusinessComponent,
    UserDetailsComponent,
    UserModulesComponent,
    UserAuditComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class UsersComponentModule {}
